import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { StripeService } from 'ngx-stripe';
import { Globals } from 'src/app/Globals';
import { HttpService } from 'src/app/services/http-service';

@Component({
  selector: 'app-reg-driver-bank',
  templateUrl: './reg-driver-bank.component.html',
  styleUrls: ['./reg-driver-bank.component.scss']
})
export class RegDriverBankComponent implements OnInit {
  globals = Globals;
  bForm: FormGroup;
  profileDetails: any = {};
  isLoadingResults = false;

  constructor(
    private service: HttpService,
    private fb: FormBuilder,
    private router: Router,
    private stripeService: StripeService
  ) {}

  ngOnInit() {
    this.stripeService.setKey(this.globals.stripe);
    this.bForm = this.fb.group({
      routingNumber: [null, [Validators.required, Validators.minLength(9), Validators.maxLength(9)]],
      accountNumber: [null, Validators.required],
      ssnlast4: ['', Validators.required]
    });
    this.profileDetails = JSON.parse(localStorage.getItem('driverProfile') || '{}');
    if (this.profileDetails) {
      this.bForm.patchValue({
        routingNumber: this.profileDetails.routingNumber,
        accountNumber: this.profileDetails.accountNumber,
        ssnlast4: this.profileDetails.ssnlast4
      });
    }
  }

  submit() {
    if (this.bForm.invalid) {
      return;
    }
    this.isLoadingResults = true;
    const routing = this.bForm.value.routingNumber;
    const account = this.bForm.value.accountNumber;
    this.stripeService.createToken('bank_account', {
      country: 'US',
      currency: 'usd',
      routing_number: routing,
      account_number: account
    }).subscribe(
      res => {
        if (res.token) {
          this.profileDetails.bankToken = res.token.id;
          this.profileDetails.accountNumber = account;
          this.profileDetails.routingNumber = routing;
          this.profileDetails.ssnlast4 = this.bForm.value.ssnlast4;
          localStorage.setItem('driverProfile', JSON.stringify(this.profileDetails));
          this.isLoadingResults = false;
          this.router.navigate(['/registration/drivers/preview']);
        } else {
          this.isLoadingResults = false;
          this.service.showError(res.error.message, 'ERROR');
        }
      },
      err => {
        this.isLoadingResults = false;
        this.service.showError(err, 'ERROR');
      }
    );
  }

  back() {
    this.router.navigate(['/registration/drivers/verification']);
  }
}
